import { defineStore } from "pinia";
import posthog from "posthog-js";
import { ref, watch } from "vue";

export default defineStore("AnalyticsStore", () => {
  const isTesting = navigator.webdriver;
  const isPostHogLoaded = ref(false);

  if (!isTesting) {
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: "/ballhog/",
      ui_host: "https://us.posthog.com",
      defaults: "2025-05-24",
      person_profiles: "identified_only",
      loaded: () => {
        isPostHogLoaded.value = true;
      },
    });
  }

  async function waitForPostHog () {
    return new Promise((resolve) => {
      if (isPostHogLoaded.value) {
        resolve(posthog);
        return;
      }

      const cancelWatch = watch(isPostHogLoaded, () => {
        if (isPostHogLoaded.value) {
          cancelWatch();
          resolve(posthog);
        }
      });
    });
  }

  function waitFor<K extends keyof typeof posthog> (method: K) {
    return async (...args: Parameters<(typeof posthog)[K]>): Promise<void> => {
      if (isTesting) return;

      await waitForPostHog();
      (posthog[method] as (...args: any[]) => void)(...args);
    };
  }

  return {
    identify: waitFor("identify"),
    reset: waitFor("reset"),
    setPersonProperties: waitFor("setPersonProperties"),
  };
});
